import { SupportedLanguage } from '@/models/TranslatableField';
import { useTranslation } from 'react-i18next';

import { LanguageSelector } from './LanguageSelector';

type QuestionFormTitleProps = {
  activeLanguage: SupportedLanguage;
  onLanguageChange: (lang: SupportedLanguage) => void;
};
export function QuestionFormTitle({
  activeLanguage,
  onLanguageChange,
}: QuestionFormTitleProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.questionsTab.createQuestionModal.questionForm',
  });

  return (
    <div className="flex justify-between items-center">
      <h3 className="text-base font-semibold text-base-content">
        {t('formTitle')}
      </h3>
      <LanguageSelector
        activeLanguage={activeLanguage}
        onLanguageChange={onLanguageChange}
      />
    </div>
  );
}
